"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
exports.default = vue_1.default.extend({
    name: 'locked-user',
    props: {},
    computed: {
        isMobile() {
            return this.$store.getters.isMobile;
        },
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
});
